import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import {
  SLowcodeList,
  STableActions,
  SActionBtn,
} from 'shj-components'
import config from './config.json';
import { getEnum, searchResponsePageByParams, sendSyncKingdeeRecordMessageReqeust, getSyncResultStatusList, getOperateTypeList } from '@/services/fmsServices'
import { Button, Divider, Menu, message, Tooltip } from 'antd';
import dayjs from 'dayjs';
import KeepAlive from 'react-activation';
export default function () {
  const listRef = useRef<any>();
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        if (rest.query.refundCreateTime) {
          rest.query.startDate = dayjs(rest.query.refundCreateTime[0]).format('YYYY-MM-DD HH:mm:ss') || undefined;
          rest.query.endDate = dayjs(rest.query.refundCreateTime[1]).format('YYYY-MM-DD HH:mm:ss') || undefined;
          delete rest.query.refundCreateTime;
        }
        rest.query.jmsQueueName = 'fmsToKdQueue';
        searchResponsePageByParams(current, pageSize, rest.query).then((res: any) => {
          resolve(res)
        });
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  const getStatusOptions = () => {
    return new Promise(async (resolve, reject) => {
      let stateArr = await getSyncResultStatusList({});
      // let receiptTypeArr = await getEnum('com.shj.saas.kingdee.enums.FmsToKdSyncTypeEnums');
      let receiptTypeArr = await getOperateTypeList({});
      // let companyArr = await getCompanyList();
      resolve({
        refundStateArr: stateArr,
        refundTypeArr: receiptTypeArr,
        // companyArr,
      });
    });
  };
  //公司列表
  const getCompanyList = () => {
    // return api.get(APIS.orgCompany).then((response: any) => {
    //   let orgCompanyList = response.data.data;
    //   return orgCompanyList;
    // });
  };
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  const onSave = useCallback((values, dialogDestroy) => {}, []);

  const onSendAgain = (record: any) => {
    const list = [];
    list.push(record.id);
    sendSyncKingdeeRecordMessageReqeust({ syncKingdeeRecordIdList: list }).then((res: any) => {
      message.success(res || '发送成功');
      reloadFn(); 
    })
  };
  const onSend = useCallback(({ record, rows, selectedRows } = {}) => {
    const list = [];
    for (let m of selectedRows) {
      list.push(m.id);
    }
    sendSyncKingdeeRecordMessageReqeust({ syncKingdeeRecordIdList: list }).then((res: any) => {
      message.success(res || '发送成功');
      reloadFn(); 
    })
  }, []);
  const disabledStatus = (data: any) => {
    let bol = false;
    //设置重发白名单
    switch (data.operateType) {
      case 'customerReceivebillCreate':
        bol = false;
        break;
      case 'customerReceivebillReCreate':
        bol = false;
        break;
      case 'customerReceivebillUpdate':
        bol = false;
        break;
      case 'customerConstructionFeeRefund':
        bol = false;
        break;
      case 'customerDesignFeeRefund':
        bol = false;
        break;
      case 'customerMainContractCreate':
        bol = false;
        break;
      case 'customerMainContractAmountUpdate':
        bol = false;
        break;
      case 'customerMainContractReceiptApplyAmountUpdate':
        bol = false;
        break;
      case 'customerMainContractRefundApplyAmountUpdate':
        bol = false;
        break;
      case 'customerMainContractUpdate':
        bol = false;
        break;
      case 'customerDesignContractCreate':
        bol = false;
        break;
      case 'customerDesignContractUpdate':
        bol = false;
        break;
      case 'customerDesignContractUpdateMainContractNo':
        bol = false;
        break;
      case 'budgetAdjustPlanCreate':
        bol = false;
        break;
      case 'budgetAdjustAdjustCreate':
        bol = false;
        break;
      default:
        bol = true;
    }
    return bol;
  };
  const extension = {
    getCheckboxProps: (record: any, index: number) => ({
      disabled: record.resultStatus === 'S',
    }),
    request: { fetchList, getStatusOptions },
    events: { onSend },
    status: {
      btnDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      kdParamOperate(text: string, record: object) {
        return (
          <Tooltip title={text} overlayStyle={{ minWidth: '150px', maxWidth: '1000px' }}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                width: '300px',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {text}
            </div>
          </Tooltip>
        );
      },
      kdExceptionMsgOperate(text: string, record: object) {
        return (
          <Tooltip title={text} overlayStyle={{ minWidth: '150px', maxWidth: '1000px' }}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                width: '300px',
                WebkitLineClamp: '2',
                WebkitBoxOrient: 'vertical',
              }}
            >
              {text}
            </div>
          </Tooltip>
        );
      },
      // 渲染操作栏
      renderOperate(text: any, record: any) {
        return (
          <div className="actionBox">
            <STableActions>
              <SActionBtn
                disabled={record.resultStatus === 'S' || disabledStatus(record)}
                onClick={() => onSendAgain(record)}
              >
                重发
              </SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  };

  return (
    <KeepAlive>
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
    </KeepAlive>
  );
}
